import { React } from 'libs/react';
import { Text } from 'components/Text';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { FormTextArea } from 'components/form/FormTextArea';
import './DealNotePanel.scss';
/**
 * @component DealNotesPanel
 * @since 1.0.0
 */
export function DealNotesPanel(props) {
    const { deal } = props;
    const internalNotes = deal.internalNotes ? deal.internalNotes : '';
    const { updateDealField } = useDealConfiguratorContext();
    return (React.createElement("div", { className: "deal-note-panel" },
        React.createElement("div", { className: "deal-note-panel-notes" },
            React.createElement(Text, { value: t('Internal notes only') }),
            React.createElement(FormTextArea, { value: internalNotes, name: "internalNotes", onChange: (value) => {
                    updateDealField('internalNotes', value, 'string');
                } }))));
}
